import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
import appApi from 'api/app';
import auth from '@/utils/auth';
import Moment from 'moment';
var state = {
  appConfig: auth.getAppConfig() || {},
  themeColor: auth.getThemeColor() || 'Light',
  configData: {},
  jumpUrl: Vue.ls.get('jumpUrl') || '',
  // 需要跳转的外部链接
  requestState: 'init',
  // 省市区json加载状态
  activitiesInfo: [],
  // 活动数据,
  skinChange: '',
  isForwardPage: false,
  // 如果是app通过forward页面打开的不隐藏头
  pushHistoryLength: auth.lsGetMarketHistoryLength() || {
    ORDER: 1,
    CROWD_ORDER: 1,
    NEW_USER: 1,
    BID_ORDER: 1 // 出价
  },
  assetHidden: 0 // 是否隐藏资产 0不隐藏 1隐藏
};
var mutations = {
  SET_APP_CONFIG: function SET_APP_CONFIG(state, data) {
    auth.setAppConfig(data);
    state.appConfig = data;
  },
  SET_THEME_COLOR: function SET_THEME_COLOR(state, str) {
    auth.setThemeColor(str);
    state.themeColor = str;
  },
  SET_CONFIG: function SET_CONFIG(state, data) {
    state.configData = data;
  },
  SET_JUMP_URL: function SET_JUMP_URL(state, str) {
    state.jumpUrl = str;
  },
  SET_REQUEST_STATE: function SET_REQUEST_STATE(state, val) {
    state.requestState = val;
  },
  SET_ACTIVITIES_INFO: function SET_ACTIVITIES_INFO(state, val) {
    state.activitiesInfo = val;
  },
  SET_SKIN_CHANGE: function SET_SKIN_CHANGE(state, val) {
    state.skinChange = val;
  },
  SET_FORWARD_PAGE: function SET_FORWARD_PAGE(state, val) {
    state.isForwardPage = val;
  },
  SET_PUSH_HISTORY_LENGTH: function SET_PUSH_HISTORY_LENGTH(state, val) {
    state.pushHistoryLength[val] += 1;
    auth.lsSetMarketHistoryLength(state.pushHistoryLength);
  },
  SET_ASSET_HIDDEN: function SET_ASSET_HIDDEN(state, val) {
    state.assetHidden = val;
  },
  RESET_PUSH_HISTORY_LENGTH: function RESET_PUSH_HISTORY_LENGTH(state, val) {
    state.pushHistoryLength[val] = 1;
    auth.lsRemoveMarketHistoryLength();
  }
};
var actions = {
  setForwardPage: function setForwardPage(_ref, data) {
    var commit = _ref.commit;
    commit('SET_FORWARD_PAGE', data);
  },
  setAssetHidden: function setAssetHidden(_ref2, data) {
    var commit = _ref2.commit;
    commit('SET_ASSET_HIDDEN', data);
  },
  setPushHistoryLength: function setPushHistoryLength(_ref3, data) {
    var commit = _ref3.commit;
    commit('SET_PUSH_HISTORY_LENGTH', data);
  },
  resetPushHistoryLength: function resetPushHistoryLength(_ref4, data) {
    var commit = _ref4.commit;
    commit('RESET_PUSH_HISTORY_LENGTH', data);
  },
  // 获取应用参数
  GetAppConfig: function GetAppConfig(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve, reject) {
      appApi.getAppConfigInfo().then(function (response) {
        commit('SET_APP_CONFIG', response.data);
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 获取通用配置
  GetConfig: function GetConfig(_ref6) {
    var commit = _ref6.commit;
    return new Promise(function (resolve, reject) {
      appApi.getConfig(null).then(function (response) {
        commit('SET_CONFIG', response);
        localStorage.setItem('prod_config', JSON.stringify({
          expirationTime: Date.now() + 180000,
          value: response
        }));
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // 友盟自定义事件PV UV 只统计线上环境
  ymSelfEvent: function ymSelfEvent(_, data) {
    if (!data || process.env.VUE_APP_ENV !== 'production') {
      return;
    }
    var id = '';
    var params = {};
    if (typeof data === 'string') {
      id = data;
    } else if (_typeof(data) === 'object') {
      id = data.id;
      params = data.params;
    }
    if (!id) {
      return;
    }
    var _window = window,
      aplus_queue = _window.aplus_queue;
    aplus_queue.push({
      action: 'aplus.record',
      arguments: [id, 'CLK', _objectSpread(_objectSpread({}, params), {}, {
        date: Moment().format('YYYY-MM-DD')
      })]
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};